"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDriverTypePropertyOption = exports.isDriverTypeProperty = exports.driverTypePropertyDefinition = void 0;
const driverTypePropertyOptions = ['Driver', 'Co-Driver'];
exports.driverTypePropertyDefinition = {
    name: 'driver-type',
    type: 'select',
    constraints: [
        {
            name: 'required',
            argument: true,
        },
        {
            name: 'options',
            argument: driverTypePropertyOptions,
        },
    ],
    multiple: false,
    default: 'Driver',
    view: { label: 'Driver Type' },
};
const isDriverTypeProperty = (prop) => {
    return prop.name === exports.driverTypePropertyDefinition.name;
};
exports.isDriverTypeProperty = isDriverTypeProperty;
const isDriverTypePropertyOption = (option) => {
    return driverTypePropertyOptions.includes(option);
};
exports.isDriverTypePropertyOption = isDriverTypePropertyOption;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZHJpdmVyLXR5cGUucHJvcGVydHkuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvcHJvcGVydGllcy9kcml2ZXItdHlwZS5wcm9wZXJ0eS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFFQSxNQUFNLHlCQUF5QixHQUFHLENBQUMsUUFBUSxFQUFFLFdBQVcsQ0FBVSxDQUFBO0FBRXJELFFBQUEsNEJBQTRCLEdBQUc7SUFDMUMsSUFBSSxFQUFFLGFBQWE7SUFDbkIsSUFBSSxFQUFFLFFBQVE7SUFDZCxXQUFXLEVBQUU7UUFDWDtZQUNFLElBQUksRUFBRSxVQUFVO1lBQ2hCLFFBQVEsRUFBRSxJQUFJO1NBQ2Y7UUFDRDtZQUNFLElBQUksRUFBRSxTQUFTO1lBQ2YsUUFBUSxFQUFFLHlCQUF5QjtTQUNwQztLQUNGO0lBQ0QsUUFBUSxFQUFFLEtBQUs7SUFDZixPQUFPLEVBQUUsUUFBUTtJQUNqQixJQUFJLEVBQUUsRUFBRSxLQUFLLEVBQUUsYUFBYSxFQUFFO0NBQ0MsQ0FBQTtBQUkxQixNQUFNLG9CQUFvQixHQUFHLENBQUMsSUFBa0IsRUFBOEIsRUFBRTtJQUNyRixPQUFPLElBQUksQ0FBQyxJQUFJLEtBQUssb0NBQTRCLENBQUMsSUFBSSxDQUFBO0FBQ3hELENBQUMsQ0FBQTtBQUZZLFFBQUEsb0JBQW9CLHdCQUVoQztBQUlNLE1BQU0sMEJBQTBCLEdBQUcsQ0FBQyxNQUFjLEVBQXNDLEVBQUU7SUFDL0YsT0FBUSx5QkFBK0MsQ0FBQyxRQUFRLENBQUMsTUFBTSxDQUFDLENBQUE7QUFDMUUsQ0FBQyxDQUFBO0FBRlksUUFBQSwwQkFBMEIsOEJBRXRDIn0=